import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputDecimal from "../../helpers/InputDecimal";
import CalculateReview from "./CalculateReview";



function Calculate(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

    const [clientsCombo, setClientsCombo] = useState(null);
    const [selectedId, setSelectedId ] = useState(defId);

    
 

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   


        fak_kontrahenci_id:  defId,   
       
        nazwa:  props.mainView.readFilter('nazwa',''),    
        opis:  props.mainView.readFilter('opis',''),   

        kwota_od:  props.mainView.readFilter('kwota_od',''),   
        kwota_do:  props.mainView.readFilter('kwota_do',''),   

        kwota_rozliczenia_od:  props.mainView.readFilter('kwota_rozliczenia_od',''),   
        kwota_rozliczenia_do:  props.mainView.readFilter('kwota_rozliczenia_do',''),   

        rozliczono:  props.mainView.readFilter('rozliczono','_x_'),   

 
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([        
        {
            cls:'color_deleted',
            title: 'pozycja nierozliczona',
             filter: {  filed: "rozliczono", set: "0", typ: "combo"  },
        },
    ]);



     const listenerSelectedId = (filedName, val, correct, msg) => 
        {
            setSelectedId(val);
        }


        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

                var defId = -1;
            if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

            props.mainView.writeFilter('nazwa', ''); 
            props.mainView.writeFilter('opis', '');

            props.mainView.writeFilter('kwota_od', '');
            props.mainView.writeFilter('kwota_do', '');

            props.mainView.writeFilter('kwota_rozliczenia_od', '');
            props.mainView.writeFilter('kwota_rozliczenia_do', '');

            props.mainView.writeFilter('rozliczono', '_');
          
           
            setFilterParam({

                fak_kontrahenci_id: defId,
                nazwa: '',                                        
                opis: '',                 
                kwota_od: '',                 
                kwota_do: '',                 
                kwota_rozliczenia_od: '',                 
                kwota_rozliczenia_do: '',                 
                rozliczono: '_x_',                 
              
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }




    const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_calc,calculate', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }




    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }


  

    const keyListener = (e) => {


                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(  code == 27 && (view.v == "assign"  || view.v == "new") )  
                        {
                                setView({v:'list',id:-1});
                        }else                                                     
                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                            e.target.blur();
                            filterClear();
                        }   else                        
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                           filterClear();
                        } else                                                                                          
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                            setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        } else                                                                  
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                               props.keyListener(e);
                        }

    }


   useEffect( ()=>{

            if(Config.env == "dev") console.log("Calculate.js, listener on");
            window.onkeydown = keyListener;   
                    
            
            return () => {   
                 if(Config.env == "dev") console.log("Calculate.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );


    




    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        filterClear();
        setTab(null);       
    }



    if(tab == null)
    {
        setTab([]);
        getTab();         
        return <div>
            ...
        </div>
    }

 

    
    
    
    var dialogBox = null;

   
 


    
    if(view.v == 'client')
    {
     //  return <ClientReview userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={view.id}   />
    }

    if( view.v == "details")
    {
        return <CalculateReview userData={props.userData} mainView={props.mainView} fak_kontrahenci_id={filterParam.fak_kontrahenci_id} keyListener={keyListener} onBack={onSuccess} onSuccess={onSuccess}  id={view.id}   />
    }
     
  
        var sortList = [                          
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "kwota", name: "Kwota"  },         
        {column: "kwota_rozliczenia", name: "Kwota rozliczenia"  },         
        {column: "data_operacji", name: "Data operacji"  },         
        {column: "firma_nazwa", name: "Nazwa firmy"  },
    ]


        document.title = "Rozliczenia" ;




    var sumKwota = 0;
    var sumRozliczono = 0;
    
    for(var k=0; k<tab.length;k++)
    {
         sumKwota = parseFloat(sumKwota) + parseFloat( tab[k].kwota );
         sumRozliczono = parseFloat(sumRozliczono) + parseFloat( tab[k].kwota_rozliczenia );
    }        
        

    return  <div className="view_content">


                 
               <h3 className="dash_header">Rozliczenia</h3>
                              

    
               <div className="table_filter">

                        {
                            filterParam.fak_kontrahenci_id < 1 &&
                            <div className="filter_controll">   
                                                <label>Klient: </label>                             
                                                <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />
                            </div> 
                        }                         

                         <div className="filter_controll">   
                                            <label>Opis: </label>                             
                                            <InputText   userData={props.userData} value={filterParam.opis}   valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Opis: "}   />
                        </div>  


                        
                        <div className="filter_controll filter_merge">   
                            <label>Kwota (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_do" placeholder={" "}   />
                        </div>
 
                    <div className="filter_controll filter_merge">   
                            <label>Kwota rozliczenia (od / do): </label>        
                            <br/>                     
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_rozliczenia_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_rozliczenia_od" placeholder={" "}   />
                            <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_rozliczenia_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_rozliczenia_do" placeholder={" "}   />
                        </div>


                        <div className="filter_controll">   
                                            <label>Rozliczono: </label>                             
                                            <InputCombo items={ [  {v:'_x_', title: '- - - '},  {v:'0', title: 'Nie'} ,  {v:'1', title: 'Tak'} ] }  userData={props.userData} value={filterParam.rozliczono}   valChange={valChangeListener} goNext={goNextNew} name="rozliczono" placeholder={": "}   />
                        </div>  
                        

                        <div className="filter_btn">                       
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                        </div> 
               </div>




                <div className="table_widget">
                                                    

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  /> 
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                </div>


               <div className="bg_center">

                        <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                                 
                                                <td>Data operacji</td>                                                                                                                                                                                              
                                                <td>Klient</td>                                                                                                                                                                                              
                                                <td>Tytuł</td>                                                                                                                                                                                                                                   
                                                <td>Strona / Typ</td>                                                                                                                                                                                                                                   
                                                <td>Kwota przelewu</td>    
                                                <td className="td_right">Kwota rozliczenia</td>    
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>


                                        <tbody>

                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
 
                                                            if(row.kwota != row.kwota_rozliczenia ) rowStyle += " color_deleted "

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="gocenter" v="details" id={row.id} onClick={changeView}>{row.data_operacji}</td>                                                                                                       
                                                                <td className="goleft" v="details" id={row.id} onClick={changeView}>{row.klient.nazwa}</td>                                                                                                       
                                                                <td className="goleft" v="details" id={row.id} onClick={changeView}>{row.opis}</td>                                                                                                                                                                               
                                                                <td className="gocenter">
                                                                    {row.strona == 'ma' && <span>Uznanie (MA)</span>}
                                                                    {row.strona == 'wn' && <span>Obciążenie (WN)</span>}
                                                                </td>                                                                                                                                                                               
                                                                <td className="goright" ><FormatDecimal value={row.kwota} /> </td>                                                                                                                    
                                                                <td className="goright" ><FormatDecimal value={row.kwota_rozliczenia} /> </td>                                                                                                                    
                                                                 <MenuTable>
                                                                    <ul>
                                                                         <li v="details" id={row.id} onClick={changeView}>Szczegóły</li>
                                                                    </ul>
                                                                </MenuTable>
                                                            </tr>

                                                    } )
                                                }

                                            <tr>                                                                                               
                                                <td></td>   
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                              
                                                <td> </td>                                                                                                                                                                                                                                   
                                                <td> </td>                                                                                                                                                                                                                                   
                                                <td className="goright gobold"><FormatDecimal value={sumKwota} /></td>    
                                                <td className="goright gobold"><FormatDecimal value={sumRozliczono}/></td>    
                                                <td></td>                                                                                  
                                            </tr>

                                        </tbody>

                                </table>

               </div>
 
              

                              
           {dialogBox}

    </div>
}


export default Calculate;